import { Checkbox } from '@consigli/facade';
import { useState, ChangeEvent } from 'react';
import { Controller, FieldValues, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

interface FormCheckboxProps {
  name: string;
  labelKey: string;
  className?: string;
  id?: string;
}

export const FormCheckbox = ({ name, labelKey, className = 'my-1', id }: FormCheckboxProps) => {
  const { control, getValues } = useFormContext<FieldValues>();
  const { t } = useTranslation();
  const [checkboxValue, setCheckboxValue] = useState<boolean>(getValues(name));

  const checkboxId = id || name;

  return (
    <span className={className}>
      <Controller
        name={name}
        control={control}
        render={({ field }) => (
          <div className="flex">
            <Checkbox
              id={checkboxId}
              label={t(labelKey)}
              onChange={(event: ChangeEvent<HTMLInputElement>) => {
                field.onChange(event.target.checked);
                setCheckboxValue(event.target.checked);
              }}
              value={checkboxValue?.toString()}
              checked={checkboxValue}
            />
          </div>
        )}
      />
    </span>
  );
};
